import { Token } from '@ui/config/token';
import type { TokenOnBonding } from '@ui/config/token/types';
import { Fraction } from 'bi-fraction';
import { create } from 'zustand';

interface BondingTradeFormStore {
  enteredAmountStr: string;
  enteredAmount: Fraction;
  fromToken: TokenOnBonding;
  toToken: TokenOnBonding;
  setEnteredAmountStr: (enteredAmountStr: string) => void;
  switchTokenPair: (type: 'buy' | 'sell') => void;
}

export const useBondingTradeForm = create<BondingTradeFormStore>((set) => ({
  enteredAmountStr: '',
  enteredAmount: Fraction.ZERO,
  fromToken: Token.agentFun,
  toToken: Token.Bonding,
  setEnteredAmountStr: (enteredAmountStr: string) => {
    set({
      enteredAmountStr,
      enteredAmount: Fraction.tryParse(enteredAmountStr) ?? Fraction.ZERO,
    });
  },
  switchTokenPair: (type) => {
    const isSell = useBondingTradeForm.getState().fromToken === Token.Bonding;
    if ((type === 'buy' && isSell) || (type === 'sell' && !isSell)) {
      useBondingTradeForm.setState({
        fromToken: useBondingTradeForm.getState().toToken,
        toToken: useBondingTradeForm.getState().fromToken,
      });
    }
  },
}));
